import { AptosClient } from "aptos";

import {
  foil_vesting_address,
  foil_swap_address,
  foil_util_address,
} from "./address";
import {
  RewardAmount,
  getCoinInfo,
  MyPoolVote,
  Pool,
  CoinInfo,
  MyRewardInfo,
} from "./pool";
import { getDecimalsAmount, get_coin_pair_by_lp } from "./swap_sdk";

const nodeUrl = process.env.REACT_APP_APTOS_NODE_URL!;

export const explorerUrl = "https://explorer.aptoslabs.com";

const _client = new AptosClient(nodeUrl);

export function getExplorerUrl(hash: string) {
  return `${explorerUrl}/txn/${hash}?network=${process.env
    .REACT_APP_APTOS_NETWORK!}`;
}

export async function client() {
  return _client;
}

export async function getAccountResource(address: string, tye: string) {
  try {
    return await _client.getAccountResource(address, tye);
  } catch (e) {
    console.log(e);
    return null;
  }
}
export async function getNowSeconds(): Promise<number> {
  const legerInfo = await _client.getLedgerInfo();
  const nowSeconds = Math.floor(
    parseInt(legerInfo.ledger_timestamp, 10) / 1000000
  );
  return nowSeconds;
}

export async function getAccountResources(address: string) {
  try {
    return await _client.getAccountResources(address);
  } catch (e) {
    console.log(e);
    return null;
  }
}

export async function getTransactionByHash(txnHash: string) {
  return await _client.getTransactionByHash(txnHash);
}

export async function get_coin_info(coin_address: string, coin: string) {
  // @ts-ignore
  return await getAccountResource(coin_address, `0x1::coin::CoinInfo<${coin}>`);
}

// get coin balance
export async function getCoinBalanceNoDecimals(
  address: string,
  coin: string
): Promise<number> {
  try {
    const data: any = await getAccountResource(
      address,
      `0x1::coin::CoinStore<${coin}>`
    );

    if (!data) {
      return 0;
    }
    return Number(data?.data?.coin?.value);
  } catch (e) {
    window.console.error(e);
    return 0;
  }
}

// get coin balance
// 1APT
export async function getCoinBalance(
  address: string,
  coin: string
): Promise<string> {
  try {
    const data: any = await getAccountResource(
      address,
      `0x1::coin::CoinStore<${coin}>`
    );

    if (!data) {
      return "0.000";
    }

    const coin_address = coin.split("::")[0];

    const coin_info = await get_coin_info(coin_address, coin);

    // @ts-ignore
    const decimals = coin_info.data.decimals;
    return getDecimalsAmount(Number(data?.data?.coin?.value), decimals);
  } catch (e) {
    window.console.error(e);
    return "0.000";
  }
}

export const getStakedLpBalance = async (
  address: string,
  coinX: string,
  coinY: string
): Promise<string> => {
  try {
    let x = coinX;
    let y = coinY;
    if (coinX > coinY) {
      x = coinY;
      y = coinX;
    }
    const pool = `${foil_swap_address}::swap::LPToken<${x}, ${y}>`;

    const type = `${foil_vesting_address}::foil::VoterState`;
    const data: any = await getAccountResource(foil_vesting_address, type);
    const gauge_handle = data.data.gauges_map.handle;
    const gauge_id = await getGaugeId(pool, gauge_handle);
    if (gauge_id < 1) return "0.000";

    const type1 = `${foil_vesting_address}::foil::GaugeState`;
    const data1: any = await getAccountResource(foil_vesting_address, type1);
    const guage_map_handle = data1.data.gauge_map.handle;

    const tableItemRequest = {
      key_type: "u64",
      value_type: `${foil_vesting_address}::foil::GaugeInfo`,
      key: `${gauge_id}`,
    };
    const gauge_info = await _client.getTableItem(
      guage_map_handle,
      tableItemRequest
    );

    const balance_of_map_handle = gauge_info.balance_of_map.handle;
    const tableItemRequest1 = {
      key_type: "address",
      value_type: "u64",
      key: address,
    };
    const balance = await _client.getTableItem(
      balance_of_map_handle,
      tableItemRequest1
    );
    // const coin_address = `${foil_swap_address}`;
    // const coin_info = await get_coin_info(coin_address, pool);
    // @ts-ignore
    // const decimals = coin_info.data.decimals;
    return balance; //getDecimalsAmount(Number(balance), decimals);
  } catch {
    return "0.000";
  }
};

export async function getVoteWeight(pool: string, handle: string) {
  try {
    const tableItemRequest = {
      key_type: "0x1::string::String",
      value_type: `${foil_util_address}::i128::I128`,
      key: pool,
    };
    const weight = await _client.getTableItem(handle, tableItemRequest);
    return weight.value;
  } catch {
    return "0";
  }
}
export async function getGaugeId(
  pool: string,
  handle: string
): Promise<number> {
  try {
    const tableItemRequest = {
      key_type: "0x1::string::String",
      value_type: "u64",
      key: pool,
    };
    const gauge_id = await _client.getTableItem(handle, tableItemRequest);
    return parseInt(gauge_id, 10);
  } catch {
    return 0;
  }
}
export const getGaugeIdFromPool = async (pool: string): Promise<number> => {
  const type = `${foil_vesting_address}::foil::VoterState`;
  const data: any = await getAccountResource(foil_vesting_address, type);
  const gauge_handle = data.data.gauges_map.handle;
  const gauge_id = await getGaugeId(pool, gauge_handle);
  return gauge_id;
};

export const getBribeReward = async (
  coin_type_info: string,
  token_id: number,
  bribe_id: number
): Promise<number> => {
  const payload = {
    function: `${foil_vesting_address}::foil::earned_view`,
    type_arguments: [],
    arguments: [coin_type_info, token_id.toString(10), bribe_id.toString(10)],
  };
  const res = await _client.view(payload);
  return parseInt(res[0] as string, 10);
};

export async function get_my_reward_amount(
  coin_type_info: string,
  token_id: number,
  user_reward_handle: string
): Promise<number> {
  try {
    const tableItemRequest = {
      key_type: "0x1::string::String",
      value_type: "0x1::table::Table<u64,u64>",
      key: `${coin_type_info}`,
    };
    const reward_coin_map = await _client.getTableItem(
      user_reward_handle,
      tableItemRequest
    );
    const reward_coin_map_handle = reward_coin_map.handle;
    const tableItemRequest1 = {
      key_type: "u64",
      value_type: "u64",
      key: `${token_id}`,
    };
    const reward_data = await _client.getTableItem(
      reward_coin_map_handle,
      tableItemRequest1
    );
    return Number(reward_data);
  } catch {
    return 0;
  }
}

export async function get_pool_votes(token_id: number): Promise<MyPoolVote[]> {
  const type_bribe = `${foil_vesting_address}::foil::BribeState`;
  const data_bribe: any = await getAccountResource(
    foil_vesting_address,
    type_bribe
  );
  const bribe_handle = data_bribe.data.bribe_map.handle;

  const type = `${foil_vesting_address}::foil::VoterState`;
  const data: any = await getAccountResource(foil_vesting_address, type);
  const pool_vote_handle = data.data.pool_vote_map.handle;
  const gauges_map_handle = data.data.gauges_map.handle;
  const tableItemRequest = {
    key_type: "u64",
    value_type: "vector<0x1::string::String>",
    key: `${token_id}`,
  };
  const pool_votes = await _client.getTableItem(
    pool_vote_handle,
    tableItemRequest
  );

  const res: MyPoolVote[] = [];
  for (let i = 0; i < pool_votes.length; i++) {
    const pool_addr = pool_votes[i];
    const [coin_address_x, coin_address_y] = get_coin_pair_by_lp(pool_addr);
    const x_coin_info = await getCoinInfo(coin_address_x);
    const y_coin_info = await getCoinInfo(coin_address_y);
    const pool: Pool = {
      x_coin_info,
      y_coin_info,
    };
    const tableItemRequest1 = {
      key_type: "0x1::string::String",
      value_type: "u64",
      key: pool_addr,
    };
    const gague_id = await _client.getTableItem(
      gauges_map_handle,
      tableItemRequest1
    );

    const tableItemRequest2 = {
      key_type: "u64",
      value_type: `${foil_vesting_address}::foil::BribeInfo`,
      key: `${token_id}`,
    };
    const bribe_info = await _client.getTableItem(
      bribe_handle,
      tableItemRequest2
    );
    const my_rewards_info: MyRewardInfo[] = [];
    const rewards_coininfo: CoinInfo[] = [];
    for (let i = 0; i < bribe_info.rewards; i++) {
      const reward_coin_type_info = bribe_info.rewards[i];
      my_rewards_info.push({
        coin_info: await getCoinInfo(reward_coin_type_info),
        reward: await get_my_reward_amount(
          reward_coin_type_info,
          token_id,
          bribe_info.user_reward_per_token_stored_map.handle
        ),
      });
      rewards_coininfo.push(await getCoinInfo(reward_coin_type_info));
    }

    res.push({
      pool,
      bribe_id: gague_id,
      rewards: my_rewards_info,
    });
  }
  return res;
}
export const isCreatedGauge = async (x: string, y: string) => {
  let coinX = x;
  let coinY = y;
  if (x > y) {
    coinX = y;
    coinY = x;
  }
  const pool = `${foil_swap_address}::swap::LPToken<${coinX}, ${coinY}>`;
  const type = `${foil_vesting_address}::foil::VoterState`;
  const data: any = await getAccountResource(foil_vesting_address, type);
  const gauges_map_handle = data.data.gauges_map.handle;

  const tableItemRequest = {
    key_type: "0x1::string::String",
    value_type: "u64",
    key: pool,
  };
  try {
    const gauge_id = await _client.getTableItem(
      gauges_map_handle,
      tableItemRequest
    );
    return gauge_id > 0;
  } catch {
    return false;
  }
};

export async function getRewardAmounts(
  gauge_id: number,
  bribe_handle: string
): Promise<RewardAmount[]> {
  if (gauge_id < 1) return [];
  try {
    const res_data: RewardAmount[] = [];
    const tableItemRequest = {
      key_type: "u64",
      value_type: `${foil_vesting_address}::foil::BribeInfo`,
      key: `${gauge_id}`,
    };
    const bribeInfo = await _client.getTableItem(
      bribe_handle,
      tableItemRequest
    );
    const rewards_coin = bribeInfo.rewards;
    for (let i = 0; i < rewards_coin.length; i++) {
      const rewards_coin_item = rewards_coin[i];
      const tableItemRequest1 = {
        key_type: "0x1::string::String",
        value_type: "u64",
        key: rewards_coin_item,
      };
      const reward = await _client.getTableItem(
        bribeInfo.reward_rate_map.handle,
        tableItemRequest1
      );
      res_data.push({
        reward_amount: (parseInt(reward, 10) / 604800).toFixed(2),
        symbol: await getSymbol(rewards_coin_item),
      });
    }
    return res_data;
  } catch {
    return [];
  }
}

export async function getMyVotes(
  pool: string,
  token_id: number,
  handle: string
): Promise<number> {
  try {
    const tableItemRequest = {
      key_type: "u64",
      value_type: `0x1::table::Table<u64,0x1::string::String>`,
      key: `${token_id}`,
    };
    const voteTable = await _client.getTableItem(handle, tableItemRequest);
    const voteTableHandle = voteTable.handle;
    const tableItemRequest1 = {
      key_type: "0x1::string::String",
      value_type: `${foil_util_address}::i128::I128`,
      key: pool,
    };
    const myVotes = await _client.getTableItem(
      voteTableHandle,
      tableItemRequest1
    );
    return parseInt(myVotes.value, 10);
  } catch {
    return 0;
  }
}

export async function getSymbol(coin_type_info: string): Promise<string> {
  const coin_address = coin_type_info.split("::")[0];
  const coin_info = await get_coin_info(coin_address, coin_type_info);
  return (coin_info!.data as any).symbol;
}
